parseTokenYYYYY